
// TODO: Denne ligger et annet sted og
import {
	Goods,
} from 'models';

export enum Direction {
	DELIVERY,
	PICKUP,
}

export enum Status {
	Planned = 'Planned',
	Received = 'Received',
	Unloaded = 'Unloaded',
	Loaded = 'Loaded',
	ReadyForPickup = 'ReadyForPickup',
	Delivered = 'Delivered',
	Completed = 'Completed',
}

export interface References {
	id?: number;
	co?: string;
	aao?: string;
}

export interface Driver {
	name: string;
	number: string;
	email: string
}
export interface Vehicle {
	licencePlate: string;
}

export interface Transporter {
	driver: Driver;
	vehicle: Vehicle;
}

export interface Trip {
	id: number;
	name: string;
}

export interface Address {
	street: string;
	zip: number;
	city: string;
	parkingLot: string;
}

export interface Time {
	start: string;
	end: string;
}

export interface Location {
	gln: string;
	name: string,
	address: Address;
	time: Time;
}

export interface Route {
	source: Location;
	destination: Location;
}

export interface Assignment {
	id: number;
	date: string;
	route: Route;
	status: Status;
	direction: string;
	goods: Goods;
	references: References;
	transporter: Transporter;
	trip: Trip
}